import type { Journey } from '@/features/journeys'
import { sortByPosition } from '@/shared/lib/sort'

/**
 * Normalizes a journeys payload into display order: journeys, their
 * active_stages and each stage's active_levels sorted by `position`.
 * The API's array order (usually id order) must never leak into the UI,
 * so consumers can rely on structural order without re-sorting.
 * Pure — input arrays are never mutated.
 */
export function sortJourneyStructure(journeys: Journey[]): Journey[] {
  return [...journeys].sort(sortByPosition).map(journey => ({
    ...journey,
    active_stages: [...(journey.active_stages ?? [])]
      .sort(sortByPosition)
      .map(stage => ({
        ...stage,
        active_levels: [...(stage.active_levels ?? [])].sort(sortByPosition)
      }))
  }))
}
